import Main from "./Main";

export const MainComponents = { Main };
